import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SimpleToggle, Typography } from '@dev/ee-components';
import styled from 'styled-components';

import { useGetSettingsInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetStep3Info';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { ToggleWrapper } from '../../../../../styled';

import { useCampaignScreensPathsChecker } from '../../../../../hooks/useCampaignScreensPathsChecker';

const DescriptionWrapper = styled.div`
    margin-left: 60px;
`;

export const SendCampaignStats = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { sendStats } = useGetSettingsInfo();
    const [toggleSendStats, setToggleSendStats] = useState(sendStats);

    const changeToggleHandler = (ev): void => {
        setToggleSendStats(ev.target.checked);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TrackingOptions.SendStats', ev.target.checked);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <>
            <ToggleWrapper>
                <SimpleToggle
                    id="campaign-statistics-toggle"
                    value="campaignstatistics"
                    checked={toggleSendStats}
                    onChange={changeToggleHandler}
                    disabled={isDetailsScreen}
                />
                <Typography variant="h3">{t('campaignstatistictoinbox')}</Typography>
            </ToggleWrapper>
            <DescriptionWrapper>
                <Typography variant="body1">{t('campaignstatistictoinbox_desc')}</Typography>
            </DescriptionWrapper>
        </>
    );
};
